export function Marke({ groesse = 24 }: { groesse?: number }) {
  return <img src="/marke.svg" width={groesse} height={groesse} alt="" aria-hidden="true" className="marke" />;
}
